// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"5f7f3788","540":"6d7b1ca9"}[chunkId] + ".chunk.css";
};